module.exports = __webpack_public_path__ + "img/countersquarerounded.ec5ef229.webp";